import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { headerLinks } from '../data/navigation';
import { business } from '../data/business';
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line bg-white/95 backdrop-blur" data-id="element-73" data-mp="2nlvdmkymwi1q">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:h-20 lg:px-8" data-id="element-74" data-mp="2rlmb17io1wf8">
        <a href="#top" aria-label={`${business.name} home`} className="rounded-lg focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan" data-id="element-75" data-mp="2wjnuvunx1zrr">
          <Logo data-id="element-76" data-mp="36bl5az73onpf" />
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-77" data-mp="369qmbqfe35nz">
          {headerLinks.map(link => <a key={link.href} href={link.href} className="text-[15px] font-medium text-navy/75 transition-colors duration-150 hover:text-navy" data-id="element-78" data-mp="3bbzdch8pbxng">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-79" data-mp="2rkq9fdx8f6kt">
          <a href={business.phoneHref} className="flex items-center gap-2 text-[15px] font-semibold text-navy transition-colors duration-150 hover:text-aqua" data-id="element-80" data-mp="2mmewgubn4fyd">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="3fbcbmokk1wmw" />
            {business.phoneDisplay}
          </a>
          <a href="#estimate" className="btn-primary !px-5 !py-3 !text-[15px]" data-id="element-82" data-mp="3abpp1oiu741f">
            Get Your Free Estimate
          </a>
        </div>

        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-xl text-navy transition-colors duration-150 hover:bg-mist lg:hidden" data-id="element-83" data-mp="35jy9e917yiq2">
          {open ? <XIcon className="h-6 w-6" data-id="element-84" data-mp="1rdbb0lqn2wq4" /> : <MenuIcon className="h-6 w-6" data-id="element-85" data-mp="1re34nr0oekdr" />}
        </button>
      </div>

      <AnimatePresence data-id="element-86" data-mp="1wbmk2u94137a">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-b border-line bg-white px-5 pb-6 pt-2 shadow-lg lg:hidden" data-id="element-87" data-mp="1weqzkns0zld9">
            <ul className="divide-y divide-line" data-id="element-88" data-mp="yovxk3n5omgw">
              {headerLinks.map(link => <li key={link.href} data-id="element-89" data-mp="yr8pn9mmod7o">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-4 text-lg font-semibold text-navy" data-id="element-90" data-mp="13n79ql0xb92a">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <a href="#estimate" onClick={() => setOpen(false)} className="btn-primary mt-4 w-full" data-id="element-91" data-mp="mfpqq1gx5ggv">
              Get Your Free Estimate
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}